import heroImg from "@/assets/hero-house-pv.jpg";

const trust = [
  "Neutrale Analyse",
  "Objektiver Vergleich",
  "Beste Entscheidung",
];

export function PublicHero() {
  return (
    <section className="relative overflow-hidden surface-sky border-b border-[var(--rule)]">
      {/* Background image - house with PV */}
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="Modernes Einfamilienhaus mit Photovoltaikanlage"
          width={1920}
          height={1080}
          className="w-full h-full object-cover object-center"
        />
        {/* Linear light overlay left → right (reduced ~50%) */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(90deg, rgba(3,24,70,0.46) 0%, rgba(255,255,255,0.44) 22%, rgba(255,255,255,0.28) 38%, rgba(255,255,255,0.09) 55%, rgba(255,255,255,0.00) 72%)",
          }}
        />
        {/* Dark navy radial top-left (reduced ~50%) */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at top left, rgba(3,24,70,0.48) 0%, rgba(3,24,70,0.28) 18%, rgba(3,24,70,0.08) 36%, rgba(3,24,70,0.00) 58%)",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 pt-12 md:pt-20 pb-16 md:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
          <div className="md:col-span-8">
            <h1 className="font-display font-normal leading-[1.05] tracking-[-0.02em] text-[2.1rem] sm:text-[2.8rem] md:text-[3.4rem] xl:text-[3.9rem]">
              <span className="block" style={{ color: "var(--gold)" }}>Potentiale verstehen.</span>
              <span className="block text-white">Förderungen nutzen.</span>
              <span className="block" style={{ color: "var(--leaf-deep)" }}>Sicher entscheiden.</span>
            </h1>
          </div>

          <aside className="md:col-span-4 md:mt-2">
            <div className="bg-white rounded-xl shadow-lg border border-[var(--rule)] p-5 md:p-6 max-w-xs ml-auto">
              <div className="flex items-center gap-2 mb-4">
                <span className="inline-flex w-7 h-7 items-center justify-center rounded-full bg-[var(--leaf-deep)] text-white">
                  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden>
                    <path d="M12 2l8 4v6c0 5-3.5 9.3-8 10-4.5-.7-8-5-8-10V6l8-4z" />
                  </svg>
                </span>
                <span className="font-display font-semibold text-navy text-sm tracking-wide">
                  100 % UNABHÄNGIG
                </span>
              </div>
              <ul className="space-y-2 text-sm text-navy">
                {trust.map((t) => (
                  <li key={t} className="flex items-center gap-2">
                    <svg viewBox="0 0 24 24" className="w-4 h-4 text-[var(--leaf)] shrink-0" fill="currentColor" aria-hidden>
                      <path d="M9 16.2l-3.5-3.6L4 14.1 9 19l11-11-1.5-1.5z" />
                    </svg>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
